export const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';
export const WEBFLOW_CLIENT_ID = "b70539f1645a387426216c631793d0fa2c96d842cda0540bdfa153f6de0d812f";
